import { RightViewArrow } from "@/components/Icons";
import React, { useState } from "react";
import Image from "next/image";

interface FAQSProps {
  image?: string;
  faqs: { question: string; answer: string }[];
}
const FAQSComp = (props: FAQSProps) => {
  const { image, faqs } = props;
  const [open, setOpen] = useState<{ [key: number]: boolean }>({});
  const handleClick = (index: number) => {
    setOpen((prev) => {
      return { ...prev, [index]: !prev[index] };
    });
  };

  return (
    <div className="mt-12  mx-auto   rounded-lg md:min-h-[540px]  mb-10">
      <h1 className="leading-9 md:text-[28px] text-[20px] font-semibold text-center md:mb-6 mb-3 ">
        Frequently Asked Questions
      </h1>
      <div className=" flex  flex-row flex-wrap w-full px-[24px] gap-7 items-center justify-center mt-8">
        <div className="hidden md:block w-[30%] relative h-[530px]">
          {image ? (
            <Image
              src={image}
              alt="faq"
              fill
              className="rounded-tl-[104px] object-cover rounded-br-[105px]"
            />
          ) : null}
        </div>
        <div className="md:max-w-[900px] max-w-[398px] max-h-[480px]  flex flex-col md:gap-6 gap-3 md:max-h-[540px]  overflow-y-auto   custom-scrollbar">
          {faqs.map(
            (faq: { question: string; answer: string }, index: number) => (
              <div
                key={index}
                className="flex flex-col  border-[2px] border-[#E5E5E5] py-6 px-4   rounded-[10px]"
              >
                <div className="flex flex-row items-center font-Gordita-Medium justify-between">
                  <h2 className="md:text-[18px] text-[14px] md:leading-9 leading-[22.8px]">
                    {faq.question}
                  </h2>
                  <p
                    onClick={() => handleClick(index)}
                    className={`transform transition-transform duration-300  cursor-pointer ${
                      open[index] ? "rotate-90" : ""
                    }`}
                  >
                    <RightViewArrow />
                  </p>
                </div>
                <div
                  className={`overflow-hidden transition-max-height duration-600 ease-in-out ${
                    open[index] ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="md:text-[16px] text-[12px] font-Gordita-Regular leading-9 text-gray-400">
                    {faq.answer}
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQSComp;
